<template>
  <auth-layout :heading="$t('heading')">
    <v-form
      ref="loginForm"
      @keyup.native.enter="submit">
      <email-input v-model="email" />
      <v-text-field
        :label="$t('labelPassword')"
        v-model="password"
        type="password"
      />
    </v-form>
    <a
      :to="{ name: 'forgotPassword' }"
      flat>
      {{ $t("forgotPassword") }}
    </a>

    <template slot="navigation">
      <v-btn
        :to="{ name: 'registration' }"
        flat>
        {{ $t("registration") }}
      </v-btn>
    </template>

    <v-btn
      slot="action"
      :disabled="isLoading"
      :loading="isLoading"
      color="primary"
      @click="submit"
    >
      {{ $t("send") }}
    </v-btn>
  </auth-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import AuthLayout from '@/components/layouts/AuthLayout'
import UserApi from '@/api/UserApi'

export default {
  name: 'Login',
  components: { AuthLayout, EmailInput },
  data () {
    return {
      isLoading: false,
      password: process.env.VUE_APP_LOGIN_PASS || '',
      email: process.env.VUE_APP_LOGIN_USER || ''
    }
  },
  computed: {
    ...mapGetters('user', ['isAuth', 'getUser'])
  },
  methods: {
    ...mapActions({
      login: 'user/login',
      setUser: 'user/setUser',
      alert: 'alert/globalAlert'
    }),
    async afterLogin () {
      if (this.isAuth) {
        this.redirect()
      }
    },
    redirect () {
      const redirectRoute = {
        company_manager: 'employees',
        employee: 'timetracking',
        user: 'subscription'
      }[this.getUser.role]
      this.$router.replace({ name: redirectRoute })
    },
    async submit () {
      if (!this.$refs.loginForm.validate()) return

      try {
        this.isLoading = true
        await this.login({ email: this.email, password: this.password })
      } catch (e) {
        this.isLoading = false
        this.$notification(e)
      }
    },
    clear () {
      this.$refs.loginForm.reset()
    }
  },
  watch: {
    isAuth: {
      handler: 'afterLogin',
      immediate: true
    }
  },

  async created () {
    try {
      let { nonce: token } = this.$route.query

      if (token) {
        const user = await UserApi.getUser(token)

        UserApi.makeAuth({
          token: `Bearer ${token}`,
          tokenLifetimeMinutes: 6
        })

        this.setUser(user)
        this.$router.push({ name: 'login' })
      }
    } catch (e) {
      this.$notification(e)
    }
  },

  i18n: {
    messages: {
      en: {
        heading: 'Login',
        labelPassword: 'Password',
        send: 'Send',
        registration: 'Registration',
        forgotPassword: 'Forgot password'
      },
      tr: {
        heading: 'Giriş',
        labelPassword: 'Şifre',
        send: 'Gönder',
        registration: 'Kayıt',
        forgotPassword: 'Şifremi unuttum'
      },
      de: {
        heading: 'Anmelden',
        labelPassword: 'Passwort',
        send: 'Login',
        registration: 'Registrierung',
        forgotPassword: 'Passwort vergessen'
      },
      ru: {
        heading: 'Вход',
        labelPassword: 'Пароль',
        send: 'Отправить',
        registration: 'Регистрация',
        forgotPassword: 'Забыли пароль'
      }
    }
  }
}
</script>
